<template>
  <v-card class="pa-1">
    <v-card-title class="pt-3 pl-2 ml-2 mb-3 pb-0 mb-0">
      {{ title }}
    </v-card-title>
    <v-card-text class="px-0">
      <v-list class="py-0">

        <template v-for="{ title, tooltip, contents, editable, key } in groups">

          <v-tooltip bottom
            :key="key"
          >
            <template #activator="{ on }">
              <u v-on="on" class="ma-2 mb-4">{{ title }}</u>
            </template>
            <span>{{ tooltip }}</span>
          </v-tooltip>

          <template v-for="content in contents">
            <nx-unpublished-contents-modal-list-item
              :key="`item-${content.id}`"
              :content-id="content.id"
              :content-type="content.type"
              :content-title="content.title"
              :content-thumbnail-url="content.thumbnailUrl"
              :content-is-published="content.isPublished"
              :subtitle="buildSubtitle(content)"
              :subtitle-color="buildSubtitleColor(content)"
              :editable="editable"
            />
            <v-spacer :key="`spacer-${content.id}`"></v-spacer>
          </template>

        </template>

      </v-list>
    </v-card-text>
    <v-card-actions class="flex justify-end">
      <v-btn color="primary" flat @click="$emit('cancel')">
        {{ $t('message.common.close') }}
      </v-btn>
      <v-btn
        flat
        color="accent"
        @click="$emit('accept')">
        {{ $t('message.common.continue') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import moment from 'moment';
import NxUnpublishedContentsModalListItem from '@/modules/content/modals/UnpublishedContentsModalListItem.vue';

export default {
  name: 'nx-unpublished-contents-modal',
  components: {
    NxUnpublishedContentsModalListItem,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    publishAction: {
      type: String,
      default: 'publish',
    },
    publishableContents: {
      type: Array,
      default: () => [],
    },
    invalidContents: {
      type: Array,
      default: () => [],
    },
    noPermissionContents: {
      type: Array,
      default: () => [],
    },
    notEligibleContents: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    buildSubtitle({
      isPublished, hasEverBeenPublished, schedulePublish, scheduleUnpublish,
    }) {
      let subtitle = '';
      if (schedulePublish) {
        subtitle += `${this.$t('message.metadata.state.scheduled')} ${moment(schedulePublish).format('DD/MM/YYYY - H:mm')} `;
      }
      if (subtitle.length > 0) {
        return subtitle;
      }

      if (hasEverBeenPublished && !isPublished) {
        subtitle += this.$t('message.metadata.state.hasBeenPublished');
      } else {
        subtitle += isPublished ? this.$t('message.metadata.state.published') : this.$t('message.metadata.state.draft');
      }

      return subtitle;
    },
    buildSubtitleColor({ isPublished }) {
      return isPublished ? 'primary' : 'undefined';
    },
  },
  computed: {
    groups() {
      const groups = [];
      let key = 1;
      if (this.publishableContents.length > 0) {
        groups.push({
          contents: this.publishableContents,
          title: this.$t('message.content.cascadePublicationContents'),
          tooltip: this.$t('message.content.cascadePublicationContents'),
          editable: true,
          key,
        });
        key += 1;
      }
      if (this.invalidContents.length > 0) {
        groups.push({
          contents: this.invalidContents,
          title: this.$t('message.content.cascadePublicationContentsWithValidationError'),
          tooltip: this.$t('message.content.cascadePublicationContentsWithValidationError'),
          editable: true,
          key,
        });
        key += 1;
      }
      if (this.notEligibleContents.length > 0) {
        groups.push({
          contents: this.notEligibleContents,
          title: this.$t('message.content.cascadePublicationContentsNotEligibleForPublication'),
          tooltip: this.$t('message.content.cascadePublicationContentsNotEligibleForPublication'),
          editable: true,
          key,
        });
        key += 1;
      }
      if (this.noPermissionContents.length > 0) {
        groups.push({
          contents: this.noPermissionContents,
          title: this.$t('message.content.cascadePublicationContentsWithoutPermissionToPublish'),
          tooltip: this.$t('message.content.cascadePublicationContentsWithoutPermissionToPublish'),
          editable: false,
          key,
        });
        key += 1;
      }

      return groups;
    },
  },
};
</script>
